"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { trackPageView } from "./lib/klaviyoClient";
import { useKlaviyoContext } from "./KlaviyoProvider";

/**
 * Component that automatically tracks page views in Klaviyo
 * Place this in your layout or root component
 */
export function KlaviyoPageTracker() {
  const pathname = usePathname();
  const { isLoaded } = useKlaviyoContext();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoaded) return;

    // Only track if the path has actually changed
    if (pathname && pathname !== lastTrackedPath.current) {
      const pageTitle = document.title || pathname;

      trackPageView(pathname, pageTitle);
      lastTrackedPath.current = pathname;
    }
  }, [pathname, isLoaded]);

  // This component doesn't render anything
  return null;
}
